interface PageHeroProps {
  eyebrow?: string
  title: string
  description: string
  compact?: boolean
}

function PageHero({ eyebrow, title, description, compact }: PageHeroProps) {
  return (
    <section className={`border-b border-slate-200 bg-[linear-gradient(180deg,#f8fafc_0%,#ffffff_100%)] ${compact ? "py-10 sm:py-12" : "py-12 sm:py-16"}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {eyebrow ? (
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700 mb-3">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-[1.75rem] sm:text-4xl font-extrabold text-slate-900 tracking-tight leading-tight">
          {title}
        </h1>
        <p className="mt-3 sm:mt-4 text-[15px] sm:text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>
      </div>
    </section>
  )
}

export default PageHero
